import React from "react"
import checkImg from "../../images/green-check-mark.png"
import styled from "styled-components"
import { colors } from "../../common/colors/app_colors"
import { makeToast } from "../../util/toast_util"

const { aTagBlue } = colors

export const ConfigFormListItem = ({ 
    isCurrentUser,
    name,
    toastAction,
    item,
    config,
    disconnectString,
    toastText,
}) => {
    const toastOnClick = () => {
        const action = {
            text: "YES",
            onClick: () => {
                toastAction(item.id, config.id)
            },
        }
        makeToast(toastText, "warning", action)
    }
    return (
        <ConGoogCalAccItemWrapper>
            <div className="check">
                {isCurrentUser && (
                    <img
                        className="check"
                        src={checkImg}
                        alt="green check mark"
                    />
                )}
            </div>
            <span className="name-email">
                {name}
            </span>
            {disconnectString && (
                <span onClick={toastOnClick} className="disconnect-link">{disconnectString}</span>
            )}
        </ConGoogCalAccItemWrapper>
    )
}

const ConGoogCalAccItemWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    width: 100%;
    margin-bottom: 5px;
    margin-top: 5px;
    .name-email {
        max-width: 60% !important;
        overflow-wrap: break-word !important;
    }
    .disconnect-link {
        cursor: pointer;
        color: ${aTagBlue};
        margin-left: auto;
    }
    .check {
        height: 10px;
        width: 12px;
        margin-right: 10px;
    }
    .vertical-align {
        margin-top: auto;
        margin-bottom: auto;
    }
`



// WEBPACK FOOTER //
// ./src/components/connected_apps/config_form_list_item.jsx